module.exports = __webpack_public_path__ + "static/media/meditation12.4fd532fb.mp3";